import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fetchButton", "fetchResult"]

  fetchVehicleKey(event) {
    event.preventDefault()
    const button = event.currentTarget
    const vin = button.dataset.vin
    // Try to get vehicle ID from form action or hidden field
    const form = button.closest('form')
    let vehicleId = null
    
    if (form && form.action) {
      const match = form.action.match(/\/driving_school_vehicles\/(\d+)/)
      if (match) vehicleId = match[1]
    }
    
    if (!vehicleId) {
      const hiddenIdField = form?.querySelector('input[name*="[id]"]')
      if (hiddenIdField) vehicleId = hiddenIdField.value
    }
    
    // If still no ID, try to get from the form's model (for new records, we'll need to save first)
    if (!vehicleId) {
      // For new vehicles, we need to save first - show a message
      this.showResult("Please save the vehicle first, then fetch the vehicle key", false)
      return
    }
    
    if (!vehicleId) {
      this.showResult("Error: Could not determine vehicle ID", false)
      return
    }

    if (!vin) {
      this.showResult("Please enter a VIN first", false)
      return
    }

    const resultTarget = this.fetchResultTarget
    resultTarget.textContent = "Fetching vehicle key..."
    resultTarget.className = "ml2 u-textSmall u-textMuted"
    button.disabled = true

    fetch(`/driving_school_vehicles/${vehicleId}/fetch_zubie_vehicle_key`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ vin: vin })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showResult(data.message, true)
        // Update the zubie_vehicle_key input field
        const keyInput = document.querySelector('input[name*="[zubie_vehicle_key]"]')
        if (keyInput) {
          keyInput.value = data.vehicle_key
        }
      } else {
        this.showResult(data.message, false)
      }
    })
    .catch(error => {
      this.showResult("Error fetching vehicle key: " + error.message, false)
    })
    .finally(() => {
      button.disabled = false
    })
  }

  showResult(message, success) {
    const resultTarget = this.fetchResultTarget
    resultTarget.textContent = message
    resultTarget.className = success 
      ? "ml2 u-textSmall u-textGreen" 
      : "ml2 u-textSmall u-textRed"
  }
}
